import React from 'react';
import { Link } from 'react-router-dom';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';

const Footer = () => {
  return (
    <div className="bg-black">
    <footer className="bg-black text-gold-primary py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-gold-primary">OHM INTERIORS</h3>
            <p className="text-gold-primary/80 mb-4">
              Transforming spaces into elegant, functional environments since our founding.
            </p>
          </div>

          {/* Location Map */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-gold-primary md:ml-[-1rem]">Location</h3>
            <div className="w-full h-[200px] rounded-lg overflow-hidden border border-gold-primary/20 md:ml-[-1rem]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3899.106290696656!2d80.24616786613726!3d13.123469047957053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265a169215555%3A0x5576175c9e63221f!2sOhm%20Interiors%20%26%20Doors!5e0!3m2!1sen!2sin!4v1748868304410!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="OHM Interiors Location"
              ></iframe>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-gold-primary">Contact Us</h3>
            <Link 
              to="/contact" 
              className="inline-block bg-gold-primary text-black font-semibold px-6 py-2 rounded-md hover:bg-gold-primary/90 transition-colors duration-300 mb-5"
            >
              Enquire Us
            </Link>
            <ul className="space-y-3 text-gold-primary/80">
              <li className="flex items-start gap-2">
                <MdEmail className="text-xl mt-0.5 flex-shrink-0" />
                <a href="mailto:ohm.interiors@outlook.com" className="hover:text-gold-primary transition-colors">
                  ohm.interiors@outlook.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MdPhone className="text-xl mt-0.5 flex-shrink-0" />
                <a href="tel:+917090011444" className="hover:text-gold-primary transition-colors">
                  +91 7090011444
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MdPhone className="text-xl mt-0.5 flex-shrink-0" />
                <a href="tel:+919340011444" className="hover:text-gold-primary transition-colors">
                  +91 9340011444
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MdLocationOn className="text-xl mt-0.5 flex-shrink-0" />
                <span>VTP Towers, No. 205, GNT Road, Erukkanchery, Chennai - 600118, Tamil Nadu</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gold-primary/30 mt-8 pt-8 text-center text-gold-primary/80">
          <p>&copy; {new Date().getFullYear()} OHM INTERIORS. All rights reserved.</p>
        </div>
      </div>
    </footer>
    </div>
  );
};

export default Footer;
